import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import CmNewsForm from "components/form/CmNewsForm";

import { SaveContextProvider } from "context/save";

import useCmNewsForm from "hooks/form/useCmNewsForm";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Notizia creata con successo",
        errorMsg: "Errore nella creazione della notizia",
        navigateTo: { link: "/cm-notizie" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovaCmNotiziaInner() {
    const formNewsHook = useCmNewsForm();

    return (
        <>
            <CmNewsForm formNewsHook={formNewsHook} />
            <ButtonSave />
        </>
    );
}

function NuovaCmNotizia() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Nuova Notizia</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <NuovaCmNotiziaInner />
            </SaveContextProvider>
        </Fragment>
    );
}

export default NuovaCmNotizia;
